import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./App.scss";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetClientCredentials, selectIsUserLoggedIn, selectLoggedInUser } from "./redux-store/LoginAuthSlice";
import { ROUTES } from "./config/routes";
import { useEffect, useState } from "react";
import { allowedPublicAccess } from "./config/allowedBypasses";
import { useCheckIfUserIsAuthenticatedQuery, useVerifyUserMutation } from "./services/login-page/LoginAuth";
import { onboardingRelatedUseEffect, registerAppRoutes, taaSRelatedUseEffect } from "./AppConfig";


function App() {
  const userDetails = useSelector(selectLoggedInUser)
  const isLoggedIn = useSelector(selectIsUserLoggedIn)
  const navigate = useNavigate()
  const location = useLocation()
  let currentPath = location.pathname
  const [verifyUser] = useVerifyUserMutation()
  const dispatch = useDispatch()
  let allowAccess = allowedPublicAccess(currentPath)
  const isOnboardingPage = currentPath.split("/")[1] === 'onboarding' ? true : false
  const shouldSkipCheckUserLogin =(!isLoggedIn || document.referrer === process.env.REACT_APP_CRP_BASE_URL.replace("api/v1", "") || currentPath===ROUTES.LOGIN || isOnboardingPage)
  const { data: isUserAuthenticated, isLoading } = useCheckIfUserIsAuthenticatedQuery(null, {skip:shouldSkipCheckUserLogin,  refetchOnFocus: !shouldSkipCheckUserLogin, refetchOnReconnect: !shouldSkipCheckUserLogin})

  useEffect(() => {
    if (!isLoggedIn) {
      if (!allowAccess) {
        navigate(ROUTES.LOGIN)
      }
    }
  }, [isLoggedIn])
  useEffect(() => {
    if (isLoggedIn) {
      if (typeof (isUserAuthenticated?.isAuth) === 'boolean') {
        if (!isUserAuthenticated?.isAuth) {
          dispatch(resetClientCredentials())
        }
      }
    }
  }, [isLoading, isUserAuthenticated])
  useEffect(() => {
    if (!isLoggedIn) {
      taaSRelatedUseEffect(currentPath, dispatch, navigate, verifyUser, location)
      onboardingRelatedUseEffect(currentPath, dispatch, navigate, verifyUser, location)
    }

  }, [])

  return registerAppRoutes(userDetails)
}

export default App



//
  // Disabling as it is creating lot of authentication issues
  // window.onbeforeunload = async () => {
  //   if (!allowAccess) {
  //     await logout()
  //   }
  //   return null;
  // }